import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from '../../assets/no-templates.svg'

const NoFiltersBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>
      No Filters Selected
    {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      Please select at least one filter to load templates.
    {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default NoFiltersBlankState
